export default {
  functionKey: "NO. SEMAINE",
  title: "NO. SEMAINE",
  group: "Date",
  origin: [],
  target: [],
  description: "Donne le n° de la semaine à partir d'une date",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const jsCode = `
      let onejan = new Date(date.getFullYear(), 0, 1);
      let weekNumber = Math.ceil((((date - onejan) / 86400000) + onejan.getDay() + 1) / 7);
      ${destination} = weekNumber;
    `;
    const safeCode = `
    let dateFormat = ${origin}.split("/").reverse().join("-");
    let date = new Date(dateFormat);
    if (isNaN(date)) { ${destination} = ''} else {
      ${jsCode}
    }
    `;
    return { displayCode: jsCode, safeCode };
  }
}
